<template>
  <div class="subject-info" id="subject-info">
    <div class="section-header">
     
      <img class="header-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115161810A012.png" alt="">
      <div class="header-title">主体信息</div>
       <img class="header-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115161810A012.png" alt="">
    </div>
    <div class="subject-content">
      <div class="subject-header">
        <div class="logo">
          <div class="logo-text">粽</div>
        </div>
      </div>
      <div class="subject-details">
        <div class="detail-item">
          <span class="label">主体名称</span>
          <span class="value">{{ subject.name }}</span>
        </div>
        <div class="detail-item">
          <span class="label">主体介绍</span>
          <span class="value description" :class="{ 'expanded': isExpanded }">
            {{ subject.description }}
          </span>
        </div>
        <div class="detail-item">
          <span class="label">联系人</span>
          <span class="value">{{ subject.contactName }}</span>
        </div>
        <div class="detail-item">
          <span class="label">联系电话</span>
          <span class="value teshu" >{{ subject.contactPhone }}</span>
        </div>
        <div class="detail-item">
          <span class="label">售后电话</span>
     
          <span class="value teshu">{{ subject.servicePhone }}</span>
        </div>
        <button @click="toggleExpand" class="expand-btn">
          {{ isExpanded ? '收起' : '展开更多' }} <span>{{ isExpanded ? '↑' : '↓' }}</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import productApi from '@/api/modules/product'

export default {
  name: 'SubjectInfo',
  props: {
    batch: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isExpanded: false,
      subject: {
        name: '',
        description: '',
        contactName: '',
        contactPhone: '',
        servicePhone: ''
      },
      trace: {
        previewImage: 'https://img2.baidu.com/it/u=3649222253,1010989529&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500',
        previewTitle: '粽叶种植',
        previewOperator: '葛榕润',
        previewTime: '2023/10/22 01:20:53'
      }
    }
  },
  mounted() {
    this.getSubjectData()
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },
    async getSubjectData() {
      try {
        // 调用主体信息列表接口获取主体信息
        const response = await productApi.getSubjectList({
          pageNum: 1,
          pageSize: 1,
          batch: this.batch
        })
        
        if (response.success && response.data && response.data.records && response.data.records.length > 0) {
          const subjectData = response.data.records[0]
          // 映射接口字段到组件字段
          this.subject = {
            name: subjectData.subjectName || '',
            description: subjectData.subjectIntroduction || '',
            contactName: subjectData.contact || '',
            contactPhone: subjectData.contactTel || '',
            servicePhone: subjectData.serviceTel || ''
          }
          console.log('获取主体信息成功:', subjectData)
        }
      } catch (error) {
        console.error('获取主体信息失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.subject-info {
  padding: 0;
  /* background-color: #fff; */
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  /* padding: 15px; */
  /* background-color: #4caf50; */
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding-top:20px;
  margin-bottom:20px;
}

.header-icon {
  width:20px;
  height:20px;
}

.subject-content {
  padding: 20px;
  background:#fff;
  border-radius: 8px;
}

.subject-header {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.logo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4caf50, #8bc34a);
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-text {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  font-family: 'Microsoft YaHei', sans-serif;
}

.subject-details {
  display: flex;
  flex-direction: column;


  
}

.detail-item {
  display: flex;
  /* flex-direction: column; */
    margin-bottom:14px;
  /* gap: 5px; */
}

.label {
  display: flex;
 
  width: 70px;
  color: #999;
  font-size: 14px;
  text-align: left;
}

.value {
  color: #333;
  font-size: 14px;
  display: flex;
  align-items: center;
  /* font-weight: 500; */
}

.value.teshu {
  padding-top: 3px;
}



.description {
  width:240px;
  text-align: left;;
  line-height: 1.5;
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  transition: all 0.3s ease;
}

.description.expanded {
  max-height: none;
  -webkit-line-clamp: unset;
}

.expand-btn {
  background: none;
  border: none;
  margin:0 auto;
  color: #4A89FE;
  font-size: 14px;
  cursor: pointer;
display: flex;
align-items: center;

}

.trace-preview {
  padding: 0;
  margin-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.trace-preview .section-header {
  margin: 0;
}

.trace-item {
  display: flex;
  gap: 15px;
  padding: 15px 20px;
}

.trace-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.trace-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.trace-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.trace-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.trace-operator,
.trace-time {
  font-size: 12px;
  color: #666;
}

.trace-tags {
  display: flex;
  gap: 8px;
  margin-top: 5px;
}

.trace-tag {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

</style>